import React, { useEffect } from "react";
import { useState } from "react";
import "./App.css";
import MainNavbar from "./Components/MainNavbar";
import GithubCredsForm from "./Components/GithubCredsForm";
import RepoContext from "./context/Repos";
import { InputSide } from "./Components/InputSide";
import { OutputSide } from "./Components/OutputSide";
import { Row, Col } from "react-bootstrap";
import {
  BsBoxArrowInRight,
  BsFileArrowDownFill,
  BsFileEarmarkArrowDownFill,
} from "react-icons/bs";
import { SiConvertio } from "react-icons/si";
import { TbPrompt } from "react-icons/tb";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import CodeMigration from "./Screens/CodeMigrator/CodeMigration";
import { ActionButtons } from "./Components/ActionButtons";
import { HomeScreen } from "./Screens/CodeMigrator/HomeScreen";
import ExcelToJsonConverter from "./Screens/CodeMigrator/sections/ExcelToJsonConverter";

function App() {
  const [InputRepo, setInputRepo] = useState(null);
  const [OutputRepo, setOutputRepo] = useState(null);
  const [InputRepoCreds, setInputRepoCreds] = useState(null);
  const [OutputRepoCreds, setOutputRepoCreds] = useState(null);
  const [srcFileTree,setSrcFileTree]=useState([]);
  const [currInputContent,setCurrInputContent]=useState({});
  const [currOutputContent,setCurrOutputContent]=useState({});
  const [destFileTree,setDestFileTree]=useState([]);
  const [multiSelect, setMultiSelect] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [initialSelection, setInitialSelection] = useState(null);

  //just for console logging
  useEffect(() => {
    console.log("InputRepo:", InputRepo);
    console.log("src tree",srcFileTree);
    console.log("dest tree",destFileTree);
    console.log("Multiselect ", multiSelect);
    console.log("Selected Files = ", selectedFiles);
  }, [InputRepo, OutputRepo, InputRepoCreds, OutputRepoCreds,srcFileTree,destFileTree,currOutputContent, multiSelect, selectedFiles, initialSelection]);

  return (
    <>
      <div>
        <RepoContext.Provider
          value={{
            InputRepo,
            OutputRepo,
            InputRepoCreds,
            OutputRepoCreds,
            setInputRepo,
            setOutputRepo,
            setInputRepoCreds,
            setOutputRepoCreds,
            srcFileTree,
            setSrcFileTree,
            destFileTree,
            setDestFileTree,
            setCurrInputContent,
            setCurrOutputContent,
            currInputContent,
            currOutputContent,
            multiSelect, 
            setMultiSelect,
            selectedFiles,
            setSelectedFiles,
            initialSelection,
            setInitialSelection,
          }}
        >
          <MainNavbar />
          {InputRepo && OutputRepo && <ActionButtons />}
          <GithubCredsForm />
          {InputRepo && OutputRepo && <CodeMigration />}
          {!InputRepo && !OutputRepo && <HomeScreen/>}
          {/* <ExcelToJsonConverter/> */}
        </RepoContext.Provider>
      </div>
    </>
  );
}

export default App;
